import { useContext } from 'react';
import { ApprovalContext } from '../context/approvalContext';
import { jsx as _jsx } from "react/jsx-runtime";
function renderIfEditable(WrappedComponent) {
  function RenderIfEditable(props) {
    const approval = useContext(ApprovalContext);
    if (!approval || !approval.data) {
      return null;
    }
    return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
  }
  return RenderIfEditable;
}
export default renderIfEditable;